import script from "./GroupAddMembersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupAddMembersModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__